import React from 'react';

import PropTypes from 'prop-types';

import classes from '@/components/common/Form/style.module.scss';

const FormComponent = ({ schema, Form: TheForm, children, ...props }) => (
  <div className={classes.form}>
    <TheForm schema={schema} {...props}>
      {children}
    </TheForm>
  </div>
);

FormComponent.propTypes = {
  schema: PropTypes.object.isRequired,
  Form: PropTypes.elementType.isRequired,
  children: PropTypes.node,
};

export default FormComponent;
